import styled from "styled-components"

export const ContactContainer = styled.footer`
  padding: 60px 0;
  background-image: linear-gradient(
    to right,
    rgba(0, 174, 239, 0.7),
    rgba(199, 230, 245, 1)
  );

  h3 {
    color: ${props => props.theme.colors.white};
    text-transform: uppercase;
    margin-bottom: 24px;
    @media (max-width: 575px) {
      text-align: center;
      margin-bottom: 40px;
    }
  }

  .contact {
    @media (max-width: 991px) {
      margin-bottom: 16px;
    }
  }

  .col-lg-6 {
    display: flex;
    align-items: center;
    @media (max-width: 575px) {
      flex-direction: column;
      justify-content: center;
      svg {
        margin-bottom: 20px;
      }
    }
    svg {
      font-size: 32px;
      color: ${props => props.theme.colors.white};
    }
    p,
    a {
      font-weight: 500;
      margin-left: 24px;
      color: ${props => props.theme.colors.white};
      text-decoration: none;
      @media (max-width: 575px) {
        margin: 0;
        text-align: center;
      }
    }
    @media (max-width: 575px) {
      flex-direction: column;
      justify-content: center;
    }
  }

  .col-lg-6:first-child {
    @media (max-width: 575px) {
      margin-bottom: 60px;
    }
  }
`

export const NewsletterContainer = styled.div`
  padding: 100px 0;
  background-image: url(${props => props.img});
  background-repeat: no-repeat;
  background-position: bottom left;

  .visuallyhidden {
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }

  .form-message {
    text-align: center;
    font-weight: 400;
    color: ${props => props.theme.colors.darkBlue};
    margin-top: 26px;

    a {
      color: ${props => props.theme.colors.brightBlue};
      font-weight: 400;
    }
  }

  h3 {
    color: ${props => props.theme.colors.darkBlue};
    margin-bottom: 20px;
  }

  form {
    display: flex;

    @media (max-width: 575px) {
      flex-direction: column;
    }

    input {
      flex: 2;
      padding: 8px;
      border: 2px solid ${props => props.theme.colors.brightBlue};
      border-radius: 8px;
      margin-right: 20px;
      &::placeholder {
        color: ${props => props.theme.colors.brightBlue};
        opacity: 1; /* Firefox */
        opacity: 0.7;
      }

      @media (max-width: 575px) {
        margin: 0;
        margin-bottom: 18px;
      }

      &:-ms-input-placeholder {
        /* Internet Explorer 10-11 */
        color: ${props => props.theme.colors.brightBlue};
        opacity: 0.7;
      }

      &::-ms-input-placeholder {
        /* Microsoft Edge */
        color: ${props => props.theme.colors.brightBlue};
        opacity: 0.7;
      }
    }
    button {
      background-color: ${props => props.theme.colors.brightBlue};
      color: ${props => props.theme.colors.white};
      border: 2px solid ${props => props.theme.colors.brightBlue};
      border-radius: 8px;
      font-weight: 600;
      padding: 8px 24px;
      transition: 0.3s ease;
      &:hover {
        background-color: ${props => props.theme.colors.white};
        color: ${props => props.theme.colors.brightBlue};
      }
    }
  }
`

export const Wrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
`

export const Copyright = styled.div`
  background-color: ${props => props.theme.colors.darkBlue};
  padding: 16px 0;
  text-align: center;
  p {
    font-size: 12px;
    color: ${props => props.theme.colors.white};
    font-weight: 600;
    a {
      font-size: 12px;
      color: ${props => props.theme.colors.white};
      font-weight: 600;
      text-decoration: none;
      transition: 0.3s ease;
      &:hover {
        color: ${props => props.theme.colors.brightBlue};
      }
    }
  }
`
